<template>
  <div class="order_item_container">
    <div class="policy_info">
      <div class="item_line">
        <span class="policy_no">保单号：0201910152324768970073</span>
        <span class="policy_state">保障中</span>
      </div>
      <div class="item_line middle_line">
        <span class="policy_start">起保时间：2019-10-31</span>
        <span class="policy_price">100.00元</span>
      </div>
      <div class="item_line">
        <span class="policy_product_name">产品名称：“家政无忧”雇主责任险</span>
        <span class="policy_company">平安保险</span>
      </div>
    </div>
    <div class="insured_info">
      <div class="insured_name">被保人员：朱士琴（*0781）</div>
      <div class="change_list">
        <div class="change_ame">李晓红（*3476）</div>
        <div class="change_ame">李晓红（*3476）</div>
        <div class="change_ame">李晓红（*3476）</div>
        <div class="change_ame">李晓红（*3476）</div>
        <div class="change_ame">李晓红（*3476）</div>
        <div class="change_ame">李晓红（*3476）</div>
      </div>
    </div>
    <div class="handle_btn_box">
      <div class="btn_item" @click="cancelInsuranceDialog">撤保</div>
      <div class="btn_item">电子保单</div>
      <div class="btn_item">电子发票</div>
    </div>
  </div>
</template>

<script>
import './OrderItem.less'
import { Dialog } from 'vant'
import { undoPolicy } from '../../api/api'

export default {
  name: 'OrderItem',
  data() {
    return {
      // 客服电话
      tel: '400-099-6778'
    }
  },
  methods: {
    // 撤保确认弹出框
    cancelInsuranceDialog() {
      let info = {
        appNo: '20180706044909781-1074747',
        channelName: '斑马'
      }
      Dialog.confirm({
        title: '提示',
        message: '确认要撤保吗?',
        confirmButtonColor: '#28cc77'
      }).then(() => {
        this.cancelInsurance(info)
      }).catch(err => {
        console.log(err)
      })
    },
    // 撤保
    async cancelInsurance(info) {
      try {
        await undoPolicy(info)
        Dialog.alert({
          title: '提示',
          message: '撤保成功',
          confirmButtonColor: '#28cc77'
        })
      } catch (error) {
        Dialog.confirm({
          title: '提示',
          message: `该保单已经生效，\n请联系客服热线${this.tel}进行退保`,
          confirmButtonText: '拨打',
          cancelButtonText: '知道啦',
          confirmButtonColor: '#28cc77'
        }).then(() => {
          // 拨打电话
          window.location.href = `tel:${this.tel}`
        }).catch(err => {
          console.log(err)
        })
      }

      // const { code, success } = data
      // if (code === 200) {
      //   if (!success) {
      //     Dialog.confirm({
      //       title: '提示',
      //       message: `该保单已经生效，\n请联系客服热线${this.tel}进行退保`,
      //       confirmButtonText: '拨打',
      //       cancelButtonText: '知道啦'
      //     }).then(() => {
      //       // 拨打电话
      //       window.location.href = `tel:${this.tel}`
      //     }).catch(err => {
      //       console.log(err)
      //     })
      //   } else {
      //     await Dialog.alert({
      //       title: '提示',
      //       message: '撤保成功',
      //       confirmButtonColor: '#28cc77'
      //     })
      //   }
      // }
    }
  }
}
</script>

<style>
</style>
